import { IPropertyDetailAdapter } from "@rf/property/module/adapters/PropertyDetailAdapter";
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode
} from "react";

type PropertyDetailPageContextProps = IPropertyDetailAdapter;

interface PropertyDetailPageProviderProps {
  children: ReactNode;
  initialData?: IPropertyDetailAdapter;
}

const PropertyDetailPageContext = createContext<
  PropertyDetailPageContextProps | undefined
>(undefined);

export const PropertyDetailPageProvider: React.FC<
  PropertyDetailPageProviderProps
> = ({ children, initialData }) => {
  const [propertyData, setPropertyData] = useState<IPropertyDetailAdapter>(
    initialData || ({} as IPropertyDetailAdapter)
  );

  useEffect(() => {
    setPropertyData(initialData || ({} as IPropertyDetailAdapter));
  }, [initialData]);

  const value = {
    ...propertyData
  };

  return (
    <PropertyDetailPageContext.Provider value={value}>
      {children}
    </PropertyDetailPageContext.Provider>
  );
};

export const usePropertyDetailPage = (): PropertyDetailPageContextProps => {
  const context = useContext(PropertyDetailPageContext);

  if (context === undefined) {
    throw new Error(
      "usePropertyDetailPage must be used within a PropertyDetailPageProvider"
    );
  }

  return context;
};
